import { enhanceUri } from 'nallian-shared-ui/lib/lib/url';
import appsettings from 'nallian-shared-ui/lib/config/appsettings';

export const apiBaseUrl = enhanceUri('v1', appsettings.vehicleDBApiBaseUrl);

export default {
  vehicles: () => `${apiBaseUrl}/vehicles?filtermode=and`,
  privateVehicles: ({ organisationId }) =>
    `${apiBaseUrl}/organisations/${organisationId}/vehicles?filtermode=and`,
  searchVehicles: input => `${apiBaseUrl}/vehicles?filtermode=or&licensePlate=${input}`,
  searchPrivateVehicles: ({ organisationId, input }) =>
    `${apiBaseUrl}/organisations/${organisationId}/vehicles?filtermode=or&licensePlate=${input}`,
  createVehicle: () => `${apiBaseUrl}/vehicles`,
  addVehicleToPrivateList: ({ organisationId, vehicleId }) =>
    `${apiBaseUrl}/organisations/${organisationId}/vehicles/${vehicleId}`,
  vehicle: vehicleId => `${apiBaseUrl}/vehicles/${vehicleId}`,
  vehicleAccessRights: vehicleId => `${apiBaseUrl}/vehicles/${vehicleId}/access-rights`,
  vehicleTypes: () => `${apiBaseUrl}/lookups/vehicle-types`,
  accessRights: () => `${apiBaseUrl}/access-rights?filtermode=and`,
  onPremiseAccessRights: ({ organisationId }) =>
    `${apiBaseUrl}/organisations/${organisationId}/access-rights?role=onPremise`,
  offPremiseAccessRights: ({ organisationId }) =>
    `${apiBaseUrl}organisations/${organisationId}/access-rights?role=offPremise`,
  accessRightsCsv: () => `${apiBaseUrl}/reports/access-rights`,
  accessLogs: () => `${apiBaseUrl}/accesslogs/filter`,
  createAccessRight: () => `${apiBaseUrl}/access-rights`,
  requestAccessRight: () => `${apiBaseUrl}/access-rights/request`, // ?
  accessRight: id => `${apiBaseUrl}/access-rights/${id}`,
  accessRightStates: () => `${apiBaseUrl}/lookups/access-right-states`,
  registerOrganisation: () => `${apiBaseUrl}/organisations/register`,
  countries: () => `${apiBaseUrl}/lookups/countries`,
  vehicleOwners: () => `${apiBaseUrl}/vehicle-owners`,
  vehicleLicensePlate: () => `${apiBaseUrl}/vehicles/license-plates`,
};
